// extracted by mini-css-extract-plugin
export default {"inputLabel":"CustomInput_inputLabel__RzWad","cardInputStyle":"CustomInput_cardInputStyle__e0qTX"};